export default container => {
  const elements = container.querySelectorAll('[data-change-bg]')

  elements.forEach(item => {
    item.querySelector('[data-bg-element]').addEventListener('click', () => {
      item.classList.toggle('opened')

      if (item.classList.contains('opened')) {
        item.style.backgroundImage = `url(${item.dataset.changeBg})`
      } else {
        item.style.backgroundImage = 'none'
      }
    })
  })
}
